<!--<div class="actions">-->
<!--  <p-button type="button" label="Print" (click)="print()"><fa-icon [icon]="faPrint"></fa-icon></p-button>-->
<!--</div>-->
@if (previewUrl) {
  <div class="preview-tool-header">
    <button [disabled]="!report" pButton type="button" class="p-button-secondary" (click)="editReport()">
      <fa-icon [icon]="faEdit"></fa-icon> Edit Report
    </button>
    @if (report && (!pdfOutput || (pdfOutput?.state === 'ready' || pdfOutput?.state === 'failed'))) {
      <button [disabled]="!report" pButton type="button" class="p-button-secondary" (click)="downloadPdf()">
        <fa-icon [icon]="faDownload"></fa-icon> Download PDF
      </button>
    }
    @if (report && pdfOutput?.state === 'pending') {
      <button pButton type="button" class="p-button-secondary">
        <fa-icon animation="spin" [icon]="faSyncAlt"></fa-icon> Creating PDF...
      </button>
    }

    @if (!report) {
      <button [disabled]="true" pButton type="button" class="p-button-secondary">
        Download PDF
      </button>
    }

    <button pButton type="button" class="p-button-secondary" (click)="shareReport()">
      <fa-icon [icon]="faShare"></fa-icon>Share Report
    </button>
  </div>
  <iframe [src]="previewUrl" class="preview-tool" #previewFrame></iframe>
}
